// Extracted from TimeSeriesChart.tsx so React Fast Refresh keeps
// working — the chart file now only exports components, and the colour
// map lives here.
//
// Hex equivalents of the Tailwind platform tokens in PlatformBadge.tsx.
// Keep in sync if the badge palette ever changes.

import type { CanonicalPlatform } from "@/lib/api";

export const PLATFORM_COLOR_HEX: Record<CanonicalPlatform, string> = {
  Instagram: "#D946EF", // fuchsia-500
  Facebook: "#3B82F6", // blue-500
  LinkedIn: "#0EA5E9", // sky-500
  TikTok: "#0A0A0A", // neutral-950
  Pinterest: "#F43F5E", // rose-500
  YouTube: "#EF4444", // red-500
  Threads: "#404040", // neutral-700
  X: "#171717", // neutral-900
  "Google Business": "#F59E0B", // amber-500
  "Other Social": "#9583FF", // purple-500 (also the "All" series default)
};
